module.exports = __webpack_public_path__ + "static/media/info.ea2f68fb.svg";